module.exports = __webpack_public_path__ + "media/images/athletes/1658-55ebf824231d88987b4dd779d214cc0a.png";